import React, { FC } from "react";
import { Menu, MenuProps } from "antd";
import { Link } from "react-router-dom";
import { IRouting } from "../../store/slices/routingSlice/routingSlice";
import {
  FileTextOutlined,
  BankOutlined,
  PercentageOutlined,
  TeamOutlined,
  ProfileOutlined,
  UsergroupAddOutlined,
} from "@ant-design/icons";

type MenuItem = Required<MenuProps>["items"][number];

interface SidebarMenuProps {
  routes: IRouting[];
  onClick: MenuProps["onClick"];
  selectedKeys: string[];
}

type TypeIcon = {
  [key: string]: React.ReactElement;
};

function getItem(
  label: React.ReactNode,
  key: React.Key,
  icon?: React.ReactNode,
  children?: MenuItem[],
  type?: "group",
  style?: React.CSSProperties
): MenuItem {
  return {
    key,
    icon,
    children,
    label,
    type,
    style: style,
  } as MenuItem;
}
const icons: TypeIcon = {
  FileTextOutlined: <FileTextOutlined />,
  BankOutlined: <BankOutlined />,
  ProfileOutlined: <ProfileOutlined />,
  TeamOutlined: <TeamOutlined />,
  PercentageOutlined: <PercentageOutlined />,
  UsergroupAddOutlined: <UsergroupAddOutlined />,
};

export const SidebarMenu: FC<SidebarMenuProps> = ({
  routes,
  onClick,
  selectedKeys,
}) => {
  let indexRoute = 0;
  const menuItemsGroup: MenuItem[] = [];

  routes?.forEach((item) => {
    if (item.title) {
      const subItems = item.routes
        ?.filter((r) => r.is_side === true)
        .map((subItem) => {
          indexRoute += 1;
          return getItem(
            <Link to={subItem.to}>{subItem.content}</Link>,
            indexRoute,
            icons[subItem.icon]
          );
        });

      menuItemsGroup.push(
        getItem(item.title, item.title, null, subItems, "group")
      );
      menuItemsGroup.push({
        type: "divider",
        style: {
          borderColor: "#009B3A",
          margin: "24px 14px",
        },
      });
    } else {
      item.routes
        ?.filter((r) => r.is_side === true)
        .forEach((subItem) => {
          indexRoute += 1;
          menuItemsGroup.push(
            getItem(
              <Link to={subItem.to}>{subItem.content}</Link>,
              indexRoute,
              icons[subItem.icon]
            )
          );
        });
    }
  });

  const menuItems = menuItemsGroup.filter((item): item is MenuItem => !!item);
  return (
    <Menu
      mode="inline"
      defaultOpenKeys={["Банковские гарантии"]}
      items={menuItems}
      onClick={onClick}
      selectedKeys={selectedKeys}
    />
  );
};
